module.exports = "/_next/static/images/373ea932278941a4af0d842b9ebbc386-two-people-looking-xs@2x.jpg";